"use client"

import { createContext, useContext, useState, useEffect } from "react"

const CartContext = createContext()

export const useCart = () => useContext(CartContext)

export const CartProvider = ({ children }) => {
  // Initialize cartItems from localStorage if available, else empty array
  const [cartItems, setCartItems] = useState(() => {
    try {
      const storedCart = localStorage.getItem("cartItems")
      return storedCart ? JSON.parse(storedCart) : []
    } catch (error) {
      console.error("Failed to parse cartItems from localStorage:", error)
      return []
    }
  })

  // Sync cartItems to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems))
  }, [cartItems])

  const addToCart = (item) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find(
        (i) =>
          i.id === item.id &&
          JSON.stringify(i.selectedModifiers) === JSON.stringify(item.selectedModifiers) &&
          i.specialNote === item.specialNote,
      )

      if (existingItem) {
        return prevItems.map((i) => (i === existingItem ? { ...i, quantity: i.quantity + item.quantity } : i))
      } else {
        return [...prevItems, { ...item }]
      }
    })
  }

  const removeFromCart = (id) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id))
  }

  const updateQuantity = (id, quantity) => {
    setCartItems((prevItems) => prevItems.map((item) => (item.id === id ? { ...item, quantity } : item)))
  }

  const clearCart = () => {
    setCartItems((prevItems) => {
      // Only update if the cart is not already empty
      if (prevItems.length === 0) {
        return prevItems // No change, return current state to prevent re-render
      }
      return [] // Clear the cart
    })
  }

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, updateQuantity, clearCart }}>
      {children}
    </CartContext.Provider>
  )
}
